import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

function NavBarMenuItems() {

    const bIsRunningLocal = window.location.origin.includes("localhost") ? true : false;

    return (
        <>
            <li key="1" className="nav-text">
                <Link to="/Dashboard">
                    <AiIcons.AiFillHome />
                    <span>Home</span>
                </Link>
            </li>
            <div style={{ paddingTop: "20px" }}>
                <span className='nav-menu-section-text'>Batch Scheduler</span>
                <li key="2" className="nav-text">
                    <Link to="https://brave-forest-0c076fc10.4.azurestaticapps.net/">
                        <AiIcons.AiOutlineSchedule />
                        <span>Scheduler</span>
                    </Link>
                </li>
            </div>
            <div style={{ paddingTop: "20px" }}>
                <span className='nav-menu-section-text'>BD Procedures</span>
                <li key="3" className="nav-text">
                    <Link to="/ProcedureDetails">
                        <FaIcons.FaCartPlus />
                        <span>Procedure Details</span>
                    </Link>
                </li>
                <li key="4" className="nav-text">
                    <Link to="/BDProcedures">
                        <IoIcons.IoIosPaper />
                        <span>Procedure Dashboard</span>
                    </Link>
                </li>
            </div>
            {bIsRunningLocal && (
                <><div style={{ paddingTop: "20px" }}>
                    <span className='nav-menu-section-text'>OnBase</span>
                    <li key="5" className="nav-text">
                        <Link to="/OnBaseFailedDocuments">
                            <IoIcons.IoIosPaper />
                            <span>Failed Documents</span>
                        </Link>
                    </li>
                    <li key="6" className='nav-text'>
                        <Link to="/OnBaseDeletedDocuments">
                            <IoIcons.IoIosPaper />
                            <span>Deleted Documents</span>
                        </Link>
                    </li>
                </div><div style={{ paddingTop: "20px" }}>
                        <span className='nav-menu-section-text'>FTP Automation</span>
                        <li key="5" className="nav-text">
                            <Link to="/FTPAutomationList">
                                <IoIcons.IoIosPaper />
                                <span>FTP Automation Setup</span>
                            </Link>
                        </li>
                    </div></>
            )};

        </>
    )
}

export default NavBarMenuItems